import React, { Component } from 'react'
import Loading from './Loading'
import { Container, Card, Form, Button } from 'react-bootstrap'
import web3 from '../ethereum/web3'
import Header from './Header'
import tokenCreator from '../ethereum/tokenCreator'

class NewToken extends Component {
    constructor(props) {
        super(props)

        this.state = {
            name: '',
            symbol: '',
            decimals: '',
            totalSupply: '',
            founder: '',
            loading: false
        }
    }

    onSubmit = async (event) => {
        event.preventDefault();

        this.setState({ loading: true });

        try {
            const accounts = await web3.eth.getAccounts();
            const newToken = await tokenCreator.methods
                .createToken(this.state.name, this.state.symbol, this.state.decimals, this.state.totalSupply, this.state.founder)
                .send({ from: accounts[0] })

        } catch (err) {
            window.alert(err.message)
        }

        this.setState({ loading: false });

    }

    render() {
        return (
            <Container >
                <Header />
                <div style={{ marginTop: '25px' }}>
                    <Card border="success" className="text-center">
                        <Card.Header>Create Your Own Token</Card.Header>
                        <Card.Body>
                            <Form onSubmit={this.onSubmit}>
                                <Form.Group>
                                    <Form.Label>Token Name</Form.Label>
                                    <Form.Control
                                        onChange={event => this.setState({ name: event.target.value })}
                                        type="text"
                                        placeholder="Token Name"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Token Symbol</Form.Label>
                                    <Form.Control
                                        onChange={event => this.setState({ symbol: event.target.value })}
                                        type="text"
                                        placeholder="Token Symbol"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Decimals</Form.Label>
                                    <Form.Control
                                        onChange={event => this.setState({ decimals: event.target.value })}
                                        placeholder="18"
                                        required
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>Total Supply</Form.Label>
                                    <Form.Control
                                        onChange={event => this.setState({ totalSupply: event.target.value })}
                                        placeholder="1000000000"
                                        required
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>Founder</Form.Label>
                                    <Form.Control
                                        onChange={event => this.setState({ founder: event.target.value })}
                                        placeholder="Founder's Ethereum Address"
                                        required
                                    />
                                </Form.Group>
                                <Button
                                    variant="success"
                                    type="submit"
                                >
                                    Create Token!
                                </Button>
                                <div style={{ float: "right" }}>
                                    {this.state.loading ? <Loading /> : ''}
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
            </Container>
        )
    }
}

export default NewToken;
